import { Box } from "@mui/material";
import MuiAvatar from "@mui/material/Avatar";
import MuiTypography from "@mui/material/Typography";
import styled from "styled-components";

export const HeaderContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const HeaderTitle = styled(MuiTypography)`
  color: ${(props) => props.theme.text.light};
  font-size: 30px;
  font-family: "Outfit-SemiBold";
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TypographyWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 18px;
  white-space: pre-wrap;
`;

export const Typography = styled(MuiTypography)`
  color: ${(props) => props.theme.text.primary};
  font-size: 14px;
  font-family: "NotoSans-Medium";
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const AvatarWrapper = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-top: 50px;
`;

export const Avatar = styled(MuiAvatar)`
  width: 128px;
  height: 128px;
  flex-shrink: 0;
`;

export const ActionsWrapper = styled(Box)`
  display: flex;
  height: 100%;
  align-items: flex-end;
  justify-content: center;
`;
